import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PayrollDefinitionService } from 'app/core/services/payroll-definition.service';
import { RefreshPeriodService } from 'app/core/services/refresh-period.service';
import { RefreshService } from 'app/core/services/refresh.service';

@Component({
  selector: 'dialog-delete-year-batch',
  templateUrl: './dialog-delete-year-batch.component.html',
  styleUrls: ['./dialog-delete-year-batch.component.scss']
})
export class DialogDeleteYearBatchComponent implements OnInit {
  isLoading: boolean = false;
  
  constructor(public dialogRef: MatDialogRef<DialogDeleteYearBatchComponent>,@Inject(MAT_DIALOG_DATA) public data: any,
              private payrollDefinitionService: PayrollDefinitionService,
              private refreshService: RefreshService,
              private refreshPeriodService: RefreshPeriodService) { }

  ngOnInit(): void {
    
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteSelectedYear() {
    this.isLoading = true;
    this.payrollDefinitionService.deleteYearBatch(this.data.selectedIds).subscribe({
      next: (res) => {
        this.refreshPeriodService.emitRefresh(this.data.selectedIds);
        Promise.resolve().then(() => {
          this.isLoading = false;
          this.dialogRef.close();
        });
      },
      error: (err) => {
        this.isLoading = true;
        console.error('Error deleting year:', err);
        alert('Failed to delete selected year.');
      },
    });
  }
}
